// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/ground-effect.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/ground-effect/ground-effect.js';

mount([g0]);
